// How page actions fold into the Buttons header cluster: at most three
// controls counting the overflow kebab, and at most one primary. With more than
// three actions the primary and the first remaining action stay visible (the
// first two when there is no primary); the rest go into the kebab in the
// consumer's order, destructive ones last.

export const MAX_PAGE_CONTROLS = 3

// Danger never initiates, so a destructive action is never the primary.
const isPrimary = action =>
  action.treatment === 'primary' && !action.destructive

/**
 * The Buttons runtime owns the fold rule, so the header kebab and the bulk-bar
 * kebab fold the same way.
 * @param {Array<object>} actions [{key, label, onSelect, href, icon, treatment, destructive, disabled}]
 * @returns {{overflow: object[], visible: object[], primary: ?object}}
 *   visible: the kept non-primary buttons in the consumer's order;
 *   primary: rendered last, at the cluster's end edge;
 *   overflow: the kebab's items, non-destructive first, then destructive
 */
export const foldPageActions = actions => {
  const list = Array.isArray(actions) ? actions.filter(Boolean) : []
  const primaryIndex = list.findIndex(isPrimary)
  const entries = list.map((action, index) => ({
    action,
    primary: index === primaryIndex,
    danger: Boolean(action.destructive),
  }))
  const folded = window.MEButtons.foldActions(entries, MAX_PAGE_CONTROLS)
  const unwrap = items => items.map(entry => entry.action)
  return {
    visible: unwrap(folded.visible.filter(entry => !entry.primary)),
    primary: primaryIndex >= 0 ? list[primaryIndex] : null,
    overflow: unwrap(folded.overflow),
  }
}
